import React, { useEffect, useState } from "react";
import config from "../../configaem";

const url = config.GUEST_MODE_URL;

const Banner = () => {
  const [iframeHeight, setIframeHeight] = useState("0px");

  useEffect(() => {
    const handleIframeMessage = (event) => {
      //   debugger
      if (event.data.re_xf_component_for_app && event.data.iframe_url === url) {
        //event.data.iframe_url -
        setIframeHeight(`${event.data.height}px`);
      }
    };
    window.addEventListener("message", handleIframeMessage);

    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, []);

  return (
    <div>
      <iframe
        src={url}
        title="Experience Fragment"
        style={{
          width: "100%",
          height: iframeHeight,
          border: "none",
          margin: "0",
          padding: "0",
          outline: "none",
          display: "block",
        }}
        id="demo-iframe"
      ></iframe>
    </div>
  );
};

export default Banner;
